var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef } from '@angular/core';
import { BasePortalHost } from 'app/ui/core/portal';
import { UIPortalHostDirective } from 'app/ui/core/portal-directives';
var UILensComponent = /** @class */ (function (_super) {
    __extends(UILensComponent, _super);
    function UILensComponent(_elementRef) {
        var _this = _super.call(this) || this;
        _this._elementRef = _elementRef;
        return _this;
    }
    UILensComponent.prototype.attachComponentPortal = function (portal) {
        var _this = this;
        setTimeout(function () { return _this._onUpdate(); });
        return this._portalHost.attachComponentPortal(portal);
    };
    UILensComponent.prototype.attachTemplatePortal = function (portal) {
        var _this = this;
        setTimeout(function () { return _this._onUpdate(); });
        this._portalHost.attachTemplatePortal(portal);
    };
    UILensComponent.prototype._onUpdate = function () {
        var _this = this;
        var beacon = document.querySelector("ui-lens-beacon[name=\"" + this.beaconName + "\"]");
        if (beacon) {
            var beaconBoundingBox = beacon.getBoundingClientRect();
            var nativeElement = this._elementRef.nativeElement;
            //nativeElement.style.left = beaconBoundingBox.left + 'px';
            //nativeElement.style.top = beaconBoundingBox.top + 'px';
            nativeElement.style.visibility = 'visible';
        }
        else {
            setTimeout(function () { return _this._onUpdate(); }, 17);
        }
    };
    UILensComponent.prototype._onResize = function () {
        this._onUpdate();
    };
    return UILensComponent;
}(BasePortalHost));
export { UILensComponent };
